import React from "react";

function IconIncoming(props) {
    return (
        <div className={props.className ? props.className : ""} >
            <svg
                className={props.svgClass ? props.svgClass : ""}
                height={props.height ? props.height : "20px"}
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                strokeLinejoin="round"
                strokeMiterlimit="2"
                clipRule="evenodd"
                viewBox="0 0 270 270"
            >
                <path
                    className={props.pathClass ? props.pathClass : ""}
                    d="M13162 4648.8h225.1c1.2 0 2.1.76 2.5 1.81v.42c.1.1.1.2.1.3v225.18c0 1.23-1 2.23-2.3 2.23h-27.4c-1.2 0-2.2-1-2.2-2.23v-172.73l-214 214.01c-.9.87-2.3.87-3.1 0l-20-19.98c-.9-.87-.9-2.28 0-3.15l214-214.01H13162c-1.3 0-2.3-1-2.3-2.23v-27.39c0-1.23 1-2.23 2.3-2.23z"
                    transform="rotate(90 9019.22 -4100.78)"
                ></path>
            </svg>
        </div>
    );
}

export default IconIncoming;